<template>
	<ChartAxisConfig v-if="leftAxisSync" v-model="leftAxisSync" :name="$t('dashboard.leftAxis')" />
	<ChartAxisConfig v-if="rightAxisSync" v-model="rightAxisSync" :name="$t('dashboard.rightAxis')" />
	<ChartAxisConfig
		v-if="bottomAxisSync"
		v-model="bottomAxisSync"
		:name="$t('dashboard.bottomAxis')"
	/>
	<ChartLegendConfig v-if="legendSync" v-model="legendSync" />
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent, PropType } from "vue";
import ChartAxisConfig from "../../config/ChartAxisConfig.vue";
import ChartLegendConfig from "../../config/ChartLegendConfig.vue";
import { defaultSpectrumOptions, SpectrumOptions } from "./spectrum-options";

export default defineComponent({
	name: "SpectrumPluginConfig",
	components: { ChartAxisConfig, ChartLegendConfig },
	props: {
		modelValue: {
			type: Object as PropType<SpectrumOptions>,
			default: () => defaultSpectrumOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const axesSync = useRefObjectSync(valueModel, "axes");
		const leftAxisSync = useRefObjectSync(axesSync, "left");
		const rightAxisSync = useRefObjectSync(axesSync, "right");
		const bottomAxisSync = useRefObjectSync(axesSync, "bottom");

		const legendSync = useRefObjectSync(valueModel, "legend");

		return { leftAxisSync, rightAxisSync, bottomAxisSync, legendSync };
	},
});
</script>
